// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/sass/elements/elements.scss
// module id = JufE
// module chunks = 0